import React from "react";
import { connect } from "react-redux";
import { reloadCarList } from "../car-listing/actions";
import { bindActionCreators } from "redux";
import DesktopRoot from "./component";

const mapStateToProps = ({
    user: {
        isLoginPopupVisible,
        isSecondaryIdentifierModalVisible
    },
    carListing: {
        isSSR
    },
    preApprovalOnFly: {
        isModalOpen: isPreApprovalModalOpen
    } = {}
}) => ({
    isLoginPopupVisible,
    isSSR,
    isPreApprovalModalOpen,
    isSecondaryIdentifierModalVisible
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    reloadCarListConnect: reloadCarList
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DesktopRoot);
